export const isSearchJobTitleEnabled = (user) => {
	return (
		(user?.search_job_title_enabled && user?.company?.search_job_title_enabled) || user?.role_can?.search_job_titles
	);
};
